module.exports = __webpack_public_path__ + "img/shopping-cart.a52efd1b.svg";